import { DateTime } from "luxon";
export default {
  methods: {
    goBack() {
      this.$router.push({
        name: "store",
        params: { storeid: this.currentstore }
      });
    },
    getStyle() {
      var styles = [];
      styles.push(this.mobileStyles.primaryBackgroundColour);
      return styles;
    },
    getCreateDate(order) {
      if (order.ScheduledTime)
        return DateTime.fromJSDate(
          new Date(order.ScheduledTime.seconds * 1000)
        ).toFormat("ff");
    }
  }
};
